import { html, TemplateResult } from "lit/html.js";

const CloseButtonTemplate = (handleCloseModal: () => void): TemplateResult =>
  html`<button @click=${handleCloseModal} class="modal-close icon-cancel" title="Close" aria-hidden="true"></button>`;

export default CloseButtonTemplate;